<template>
  <div>
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      :default-sort="{ prop: 'id', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="150"
      >
        <template slot-scope="scope">
          <LicensePlate
            :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate"
            :chars="alphaList"
          ></LicensePlate>
        </template>
      </el-table-column>

      <el-table-column
        prop="fuel_type"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FUEL_TYPE')"
        width="140"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('FUEL_TYPE')"
            class="text-sm"
            v-if="scope.row.fuel_type"
          >
            {{
              $i18n.locale == 'fa'
                ? scope.row.fuel_type.fa_title
                : scope.row.fuel_type.en_title
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="amount"
        align="center"
        :label="$t('amount')"
        width="120"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('amount')"
            v-html="$options.filters.numberSeperator1(scope.row.amount)"
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DATE_')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DATE_')">
            {{ gregorianToJalali(scope.row.date) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="" width="120">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :Editable="false"
              @remove="remove(scope.row.id)"
              :title="$t('fuel_quota')"
              :isDeleteable="true"
              @open="open($event)"
              :description="scope.row.description"
              :view="false"
            >
              <i
                class="
                  el-icon-edit-outline
                  text-xl
                  cursor-pointer
                  text-yellow-500
                "
                @click="editQuota(scope.row)"
              ></i>
            </tableFeatures>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <FuelTransactionForm
      :show.sync="showTransactionForm"
      :transaction="currentTransaction"
      @transaction-updated="handleQuotaUpdated"
      formType="simpleForm"
    />
  </div>
</template>

<script>
import tableFeatures from '@/components/elements/tableFeatures'
import LicensePlate from '@/components/cars/LicensePlate'
import { licenseChars } from '@/api/global'
import { numberWithSpaces } from '@/mixins/numberWithSpaces'
import { open } from '@/mixins/openDesc'
import { removeFuelQuotas } from '@/api/fuel'
import FuelTransactionForm from '@/components/fuel/FuelTransactionForm'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { currency } from '@/mixins/currency'

export default {
  props: ['tableData', 'loading'],
  mixins: [numberWithSpaces, open, gregorianToJalali, currency],
  data() {
    return {
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      showTransactionForm: false,
      currentTransaction: {},
    }
  },
  components: {
    LicensePlate,
    tableFeatures,
    FuelTransactionForm,
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  methods: {
    remove(id) {
      removeFuelQuotas.api(id).then((res) => {
        if (res) {
          this.$notify.success({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('fuel_quota'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.$emit('quota-removed', id)
        }
      })
    },

    editQuota(quota) {
      // Prepare the quota data for the simpleForm
      this.currentTransaction = {
        // For a quota we only need these fields:
        date: this.gregorianToJalali(quota.date),
        amount: this.currency(quota.amount),
        fuel_type: quota.fuel_type.id,
        company_vehicle: quota.company_vehicle.id,
        description: quota.description || '',
        id: quota.id, // Store the ID for update operation
      }

      // Show the form
      this.showTransactionForm = true
    },

    handleQuotaUpdated(updatedQuota) {
      // Emit event to parent component to update the specific quota in the list
      this.$emit('quota-updated', updatedQuota)
    },
  },
}
</script>
